export default function Component({ type }: { type: string }) {
  return (
    <div className="bg-gradient-600 py-12 text-center text-4xl font-bold text-white">
      Could not find block {type}
    </div>
  )
}
